import { render, staticRenderFns } from "./edit-zhuanbing-zhenghou.vue?vue&type=template&id=61a023e6&scoped=true&"
import script from "./edit-zhuanbing-zhenghou.vue?vue&type=script&lang=ts&"
export * from "./edit-zhuanbing-zhenghou.vue?vue&type=script&lang=ts&"
import style0 from "./edit-zhuanbing-zhenghou.vue?vue&type=style&index=0&id=61a023e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a023e6",
  null
  
)

export default component.exports